(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["card-add-to-cart"] && !Shopify.designMode) return;
  try {
    class CardAddToCart extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('.cart-btn__form');
      this.label = this.querySelector('.cart-btn__label');
      if (!this.form || !this.label) return;

      this.original = this.label.innerHTML;
      this.form.addEventListener('submit', (e) => this.onSubmit(e));
    }

    async onSubmit(e) {
      e.preventDefault();
      this.dataset.state = 'loading';
      this.label.textContent = 'Adding...';

      const root = window.Shopify?.routes?.root || '/';

      try {
        const res = await fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            items: [{ id: Number(this.form.dataset.variantId), quantity: 1 }],
          }),
        });

        if (!res.ok) throw new Error(await res.text());

        this.label.textContent = 'Added';
        await this.notifyTheme(root);

        setTimeout(() => {
          this.label.innerHTML = this.original;
          this.dataset.state = '';
        }, 1500);
      } catch (err) {
        console.error('[card-add-to-cart] failed:', err);
        this.label.textContent = 'Try again';
        this.dataset.state = '';
        setTimeout(() => {
          this.label.innerHTML = this.original;
        }, 2000);
      }
    }

    // Horizon listens for its own CartUpdateEvent, not generic cart events.
    // This is what refreshes the bag count and pops the drawer.
    async notifyTheme(root) {
      try {
        const { CartUpdateEvent } = await import('@theme/events');
        const cart = await (await fetch(root + 'cart.js')).json();

        document.dispatchEvent(
          new CartUpdateEvent(cart, 'card-add-to-cart', {
            itemCount: cart.item_count,
            source: 'card-add-to-cart',
            sections: {},
          })
        );

        const drawer = document.querySelector('cart-drawer-component');
        if (drawer?.hasAttribute('auto-open')) drawer.open();
      } catch (err) {
        // Theme module missing or renamed — fall back to a reload so the
        // customer at least sees the correct cart.
        console.warn('[card-add-to-cart] could not reach @theme/events, reloading:', err);
        window.location.reload();
      }
    }
  }

  if (!customElements.get('card-add-to-cart')) customElements.define('card-add-to-cart', CardAddToCart);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["link-buttons"] && !Shopify.designMode) return;
  try {
    class LinkButtons extends HTMLElement {
    connectedCallback() {
      this.offset = parseInt(this.dataset.scrollOffset, 10) || 0;
      this.addEventListener('click', this.onClick.bind(this));
    }

    onClick(event) {
      // Chat button: open the Gorgias chat widget instead of navigating.
      const chatBtn = event.target.closest('[data-chat]');
      if (chatBtn) {
        event.preventDefault();
        this.openChat();
        return;
      }

      const link = event.target.closest('[data-scroll]');
      if (!link) return;

      const hash = link.getAttribute('href');
      if (!hash || hash.length < 2) return;

      let destination;
      try {
        destination = document.querySelector(hash);
      } catch (e) {
        return; // Not a usable selector — let the browser deal with it.
      }
      if (!destination) return; // No such id on this page; fall through.

      event.preventDefault();

      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const top = destination.getBoundingClientRect().top + window.scrollY - this.offset;

      window.scrollTo({ top, behavior: reduced ? 'auto' : 'smooth' });

      // Keep the address bar honest without adding a history entry, so the
      // back button still returns to the previous page rather than undoing
      // the scroll.
      history.replaceState(null, '', hash);
    }

    // Opens the Gorgias chat widget (installed as an app embed, so it's on the
    // window rather than in the theme). Tries the JS API first, then falls back
    // to clicking the floating chat button; retries briefly in case the widget
    // script hasn't finished loading when the shopper clicks.
    openChat(attempt = 0) {
      const g = window.GorgiasChat;
      if (g) {
        if (typeof g.open === 'function') return g.open();
        if (typeof g.toggle === 'function') return g.toggle();
      }

      const button = document.querySelector(
        '#gorgias-chat-container button, #gorgias-chat-messenger-button, [id^="gorgias-chat"] [role="button"]'
      );
      if (button) return button.click();

      // Widget not ready yet — retry a few times over ~2s.
      if (attempt < 10) setTimeout(() => this.openChat(attempt + 1), 200);
    }
  }

  if (!customElements.get('link-buttons')) customElements.define('link-buttons', LinkButtons);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["peek-carousel"] && !Shopify.designMode) return;
  try {
    class PeekCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.peek__track');
      // allSlides = every image; slides = the currently-visible set (a variant
      // filter hides the rest). The arrow/counter maths run on `slides` only.
      this.allSlides = Array.from(this.querySelectorAll('.peek__slide'));
      this.slides = this.allSlides.filter((s) => !s.classList.contains('peek__slide--hidden'));
      this.arrows = Array.from(this.querySelectorAll('.peek__arrow'));
      this.counter = this.querySelector('[ref="current"]');
      this.total = this.querySelector('[ref="total"]');
      this.badge = this.querySelector('.peek__badge');
      if (!this.track || this.allSlides.length < 1) return;

      this.index = 0;
      // reals = the visible real slides for the current variant; sequence adds
      // the loop clones after them. `slides` stays an alias for compatibility.
      this.reals = this.slides;
      this.sequence = this.reals.slice();

      this.arrows.forEach((btn) => {
        btn.addEventListener('click', () => this.move(Number(btn.dataset.dir)));
      });

      // Derive the index from scrollLeft, not from visibility. With narrow
      // slides several are visible at once, so an IntersectionObserver
      // reports the wrong "current" slide and the back arrow stops working.
      let ticking = false;
      this.track.addEventListener('scroll', () => {
        if (!ticking) {
          ticking = true;
          requestAnimationFrame(() => {
            this.update();
            ticking = false;
          });
        }
        // Once scrolling settles, hop out of the clone zone seamlessly.
        clearTimeout(this._settle);
        this._settle = setTimeout(() => this.maybeLoop(), 130);
      });
      this.track.addEventListener('scrollend', () => this.maybeLoop());

      this.addEventListener('keydown', (e) => {
        if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
        e.preventDefault();
        this.move(e.key === 'ArrowLeft' ? -1 : 1);
      });

      this.bindVariants();

      // Filter + order the initial variant (primary first) and build the loop.
      const initId = document.querySelector('form[action*="/cart/add"] input[name="id"]')?.value;
      if (initId && this.variantMedia && Array.isArray(this.variantMedia[String(initId)])) {
        this.applyVariant(initId);
      } else {
        this.setupLoop();
      }

      this.update();
    }

    // Distance from one slide's start to the next, including any gap.
    get step() {
      const r = this.reals || [];
      if (r.length < 2) return r[0]?.offsetWidth || 1;
      return r[1].offsetLeft - r[0].offsetLeft;
    }

    update() {
      const r = this.reals || [];
      if (r.length === 0) return;
      const n = r.length;
      const raw = Math.round(this.track.scrollLeft / this.step);
      const realIndex = ((raw % n) + n) % n;
      this.index = realIndex;

      // Highlight whichever slide is centred — real OR clone.
      const seq = this.sequence || r;
      seq.forEach((el, k) => el.classList.toggle('is-active', k === raw));

      if (this.counter) this.counter.textContent = String(realIndex + 1);
      this.arrows.forEach((btn) => {
        btn.disabled = false;
      });
    }

    smoothTo(left) {
      this.track.scrollTo({
        left,
        behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
      });
    }

    // Arrow / key navigation with a real loop. Going right off the end scrolls
    // into a clone of the first image; maybeLoop() then snaps back seamlessly.
    move(dir) {
      const n = (this.reals || []).length;
      if (n < 2) return;
      const s = this.step;
      const raw = Math.round(this.track.scrollLeft / s);

      if (dir < 0 && raw <= 0) {
        // Loop left: hop to the first clone (identical to image 1) instantly,
        // then slide one step left onto the last real image.
        this.track.style.scrollBehavior = 'auto';
        this.track.scrollLeft = n * s;
        this.track.style.scrollBehavior = '';
        this.smoothTo((n - 1) * s);
      } else {
        this.smoothTo((raw + dir) * s);
      }
    }

    // Once scrolling settles inside the clone zone, jump back by one full loop
    // to the identical real slide — invisible because the images match.
    maybeLoop() {
      const n = (this.reals || []).length;
      if (n < 2) return;
      const s = this.step;
      const raw = Math.round(this.track.scrollLeft / s);
      if (raw >= n) {
        this.track.style.scrollBehavior = 'auto';
        this.track.scrollLeft = this.track.scrollLeft - n * s;
        this.track.style.scrollBehavior = '';
        this.update();
      }
    }
    async bindVariants() {
      const json = this.querySelector('[data-variant-media]');
      if (!json) return;

      try {
        this.variantMedia = JSON.parse(json.textContent);
      } catch {
        return;
      }

      // Per-variant preorder flags for the stock badge.
      const pre = this.querySelector('[data-variant-preorder]');
      if (pre) {
        try {
          this.variantPreorder = JSON.parse(pre.textContent);
        } catch {
          this.variantPreorder = null;
        }
      }

      try {
        const { ThemeEvents } = await import('@theme/events');
        document.addEventListener(ThemeEvents.variantUpdate, (e) => this.onVariant(e));
      } catch (err) {
        console.warn('[peek-carousel] @theme/events unavailable:', err);
      }

      // Belt and braces: the variant picker also updates the hidden id input.
      const form = document.querySelector('form[action*="/cart/add"]');
      if (form) {
        form.addEventListener('change', () => {
          const id = form.querySelector('input[name="id"]')?.value;
          if (id) {
            this.applyVariant(id);
            this.updateBadge(id);
          }
        });
      }
    }

    onVariant(e) {
      const d = e.detail || {};
      const id =
        d.data?.variant?.id ??
        d.resource?.selected_or_first_available_variant?.id ??
        d.variant?.id;

      if (id) {
        this.applyVariant(id);
        this.updateBadge(id);
      }
    }

    // Swap the stock badge between "In stock" and "Preorder" for the selected
    // variant (its preorder.preorder_status metafield), keeping the locale text.
    updateBadge(variantId) {
      if (!this.badge || !this.variantPreorder) return;
      const isPre = this.variantPreorder[String(variantId)] === true;
      const label = isPre ? this.badge.dataset.labelPreorder : this.badge.dataset.labelInStock;
      if (label) this.badge.textContent = label;
    }

    // Show only the selected variant's images (ProductWiz map), hide the rest,
    // then reset to the first image. The map value is an array of media ids;
    // when a variant has no mapping we leave the carousel untouched.
    applyVariant(variantId) {
      const ids = this.variantMedia?.[String(variantId)];
      if (!Array.isArray(ids) || ids.length === 0) return;

      const allow = new Set(ids.map(String));
      this.allSlides.forEach((slide) => {
        const show = allow.has(String(slide.dataset.mediaId));
        slide.classList.toggle('peek__slide--hidden', !show);
        slide.toggleAttribute('hidden', !show);
      });

      // Reorder the track so the variant's images are contiguous and in the
      // app's order: hidden slides first (they take no layout space), then the
      // visible ones primary-first. This makes the carousel start on the primary
      // image with the rest to its RIGHT, and keeps every mapped image reachable.
      const byId = new Map(this.allSlides.map((s) => [String(s.dataset.mediaId), s]));
      const ordered = ids.map((id) => byId.get(String(id))).filter(Boolean);
      const hidden = this.allSlides.filter((s) => !ordered.includes(s));
      hidden.forEach((s) => this.track.appendChild(s));
      ordered.forEach((s) => this.track.appendChild(s));

      this.reals = ordered.length
        ? ordered
        : this.allSlides.filter((s) => !s.classList.contains('peek__slide--hidden'));
      this.slides = this.reals;

      this.setupLoop();

      if (this.total) this.total.textContent = String(this.reals.length);

      this.index = 0;
      this.track.style.scrollBehavior = 'auto';
      this.track.scrollLeft = 0;
      this.track.style.scrollBehavior = '';
      this.update();
    }

    // Append a clone of each visible slide after the reals, so the first image
    // follows the last. This is what makes the loop seamless AND lets the final
    // real image reach the centre (a plain peek carousel can't — nothing sits
    // to its right to scroll it in).
    setupLoop() {
      this.track.querySelectorAll('[data-peek-clone]').forEach((c) => c.remove());
      const r = this.reals || [];
      if (r.length < 2) {
        this.sequence = r.slice();
        return;
      }
      const clones = r.map((s) => {
        const c = s.cloneNode(true);
        c.setAttribute('data-peek-clone', '');
        c.setAttribute('aria-hidden', 'true');
        c.classList.remove('is-active', 'peek__slide--hidden');
        c.removeAttribute('hidden');
        this.track.appendChild(c);
        return c;
      });
      this.sequence = [...r, ...clones];
    }
  }

  if (!customElements.get('peek-carousel')) customElements.define('peek-carousel', PeekCarousel);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["quick-filters"] && !Shopify.designMode) return;
  try {
    class QuickFilters extends HTMLElement {
    connectedCallback() {
      this.buttons = Array.from(this.querySelectorAll('.qfilters__btn'));
      this.mark();
      // Re-mark if the theme filters via AJAX and updates the URL without a reload.
      window.addEventListener('popstate', () => this.mark());
    }

    mark() {
      const params = window.location.search.replace(/^\?/, '');

      // Strip sort_by and grid so they don't affect the match.
      const clean = (s) =>
        s
          .split('&')
          .filter((p) => p && !p.startsWith('sort_by=') && !p.startsWith('grid='))
          .sort()
          .join('&');

      const now = clean(params);

      let matched = false;
      this.buttons.forEach((btn) => {
        const q = clean(btn.dataset.query || '');
        const active = q !== '' && q === now;
        btn.classList.toggle('is-active', active);
        if (active) matched = true;
      });

      // If nothing matched and there are no filters, light up the "All"
      // button (the one whose query is empty).
      if (!matched && now === '') {
        const all = this.buttons.find((b) => (b.dataset.query || '') === '');
        if (all) all.classList.add('is-active');
      }
    }
  }

  if (!customElements.get('quick-filters')) customElements.define('quick-filters', QuickFilters);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["upsell-card"] && !Shopify.designMode) return;
  try {
    class UpsellCard extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('.upsell-card__form');
      this.label = this.querySelector('.upsell-card__label');
      if (!this.form || !this.label) return;

      this.original = this.label.innerHTML;
      this.form.addEventListener('submit', (e) => this.onSubmit(e));
    }

    async onSubmit(e) {
      e.preventDefault();
      this.dataset.state = 'loading';
      this.label.textContent = 'Adding...';

      const root = window.Shopify?.routes?.root || '/';

      try {
        const res = await fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            items: [{ id: Number(this.form.dataset.variantId), quantity: 1 }],
          }),
        });

        if (!res.ok) throw new Error(await res.text());

        this.label.textContent = 'Added';
        await this.notifyTheme(root);

        setTimeout(() => {
          this.label.innerHTML = this.original;
          this.dataset.state = '';
        }, 1500);
      } catch (err) {
        console.error('[upsell-card] failed:', err);
        this.label.textContent = 'Try again';
        this.dataset.state = '';
        setTimeout(() => {
          this.label.innerHTML = this.original;
        }, 2000);
      }
    }

    // Horizon listens for its own CartUpdateEvent, not generic cart events.
    async notifyTheme(root) {
      try {
        const { CartUpdateEvent } = await import('@theme/events');
        const cart = await (await fetch(root + 'cart.js')).json();

        document.dispatchEvent(
          new CartUpdateEvent(cart, 'upsell-card', {
            itemCount: cart.item_count,
            source: 'upsell-card',
            sections: {},
          })
        );

        const drawer = document.querySelector('cart-drawer-component');
        if (drawer?.hasAttribute('auto-open')) drawer.open();
      } catch (err) {
        console.warn('[upsell-card] could not reach @theme/events, reloading:', err);
        window.location.reload();
      }
    }
  }

  if (!customElements.get('upsell-card')) customElements.define('upsell-card', UpsellCard);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["watch-split-spin"] && !Shopify.designMode) return;
  try {
    class SpinViewer extends HTMLElement {
    connectedCallback() {
      this.urls = (this.dataset.frames || '').split(',').filter(Boolean);
      if (this.urls.length === 0) return;

      this.canvas = this.querySelector('.spin-viewer__canvas');
      this.ctx = this.canvas.getContext('2d');
      this.bar = this.querySelector('.spin-viewer__bar');

      this.sensitivity = parseFloat(this.dataset.dragSensitivity) || 6;
      this.reverse = this.dataset.reverse === 'true';
      this.frames = [];
      this.index = 0;
      this.loaded = 0;
      this.ready = false;

      // Don't pull ~2MB of frames until the viewer is actually near the screen.
      const io = new IntersectionObserver(
        (entries) => {
          if (entries.some((e) => e.isIntersecting)) {
            io.disconnect();
            this.preload();
          }
        },
        { rootMargin: '400px' }
      );
      io.observe(this);
    }

    preload() {
      this.urls.forEach((url, i) => {
        const img = new Image();
        img.decoding = 'async';
        img.onload = () => {
          this.loaded += 1;
          this.bar.style.width = (this.loaded / this.urls.length) * 100 + '%';
          if (this.loaded === this.urls.length) this.onReady();
        };
        // A missing frame shouldn't hang the whole viewer forever.
        img.onerror = img.onload;
        img.src = url;
        this.frames[i] = img;
      });
    }

    onReady() {
      this.ready = true;
      this.resize();
      this.draw();
      this.dataset.ready = 'true';

      this.bindDrag();
      new ResizeObserver(() => {
        this.resize();
        this.draw();
      }).observe(this);

      if (this.dataset.idleSpin === 'true' && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
        this.startIdleSpin();
      }
    }

    resize() {
      const dpr = Math.min(window.devicePixelRatio || 1, 2); // cap at 2x — 3x is wasted pixels
      const rect = this.getBoundingClientRect();
      this.canvas.width = rect.width * dpr;
      this.canvas.height = rect.height * dpr;
    }

    draw() {
      const img = this.frames[this.index];
      if (!img || !img.naturalWidth) return;

      const cw = this.canvas.width;
      const ch = this.canvas.height;
      const scale = Math.min(cw / img.naturalWidth, ch / img.naturalHeight);
      const w = img.naturalWidth * scale;
      const h = img.naturalHeight * scale;

      this.ctx.clearRect(0, 0, cw, ch);
      this.ctx.drawImage(img, (cw - w) / 2, (ch - h) / 2, w, h);
    }

    step(delta) {
      const n = this.frames.length;
      this.index = (((this.index + delta) % n) + n) % n; // wrap both directions
      this.draw();
    }

    startIdleSpin() {
      let last = 0;
      const tick = (now) => {
        if (this.dataset.touched === 'true') return; // user took over; stop forever
        if (now - last > 60) {
          this.step(this.reverse ? -1 : 1);
          last = now;
        }
        this.raf = requestAnimationFrame(tick);
      };
      this.raf = requestAnimationFrame(tick);
    }

    bindDrag() {
      let startX = 0;
      let startIndex = 0;
      let dragging = false;

      const onDown = (e) => {
        if (!this.ready) return;
        dragging = true;
        startX = e.clientX;
        startIndex = this.index;
        this.dataset.dragging = 'true';
        this.dataset.touched = 'true';
        if (this.raf) cancelAnimationFrame(this.raf);
        this.setPointerCapture(e.pointerId);
      };

      const onMove = (e) => {
        if (!dragging) return;
        const px = (e.clientX - startX) * (this.reverse ? -1 : 1);
        const delta = Math.round(px / this.sensitivity);
        const n = this.frames.length;
        this.index = (((startIndex + delta) % n) + n) % n;
        this.draw();
      };

      const onUp = (e) => {
        dragging = false;
        this.dataset.dragging = 'false';
        if (this.hasPointerCapture(e.pointerId)) this.releasePointerCapture(e.pointerId);
      };

      this.addEventListener('pointerdown', onDown);
      this.addEventListener('pointermove', onMove);
      this.addEventListener('pointerup', onUp);
      this.addEventListener('pointercancel', onUp);

      // Keyboard support.
      this.tabIndex = 0;
      this.setAttribute('role', 'img');
      this.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft') {
          this.dataset.touched = 'true';
          this.step(-1);
        }
        if (e.key === 'ArrowRight') {
          this.dataset.touched = 'true';
          this.step(1);
        }
      });
    }
  }

  class WatchSplit extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('[data-view]'));
      this.panels = Array.from(this.querySelectorAll('[data-view-panel]'));
      this.tabs.forEach((tab) => {
        tab.addEventListener('click', () => this.select(tab.dataset.view));
      });
    }

    select(view) {
      this.tabs.forEach((tab) => {
        tab.setAttribute('aria-selected', String(tab.dataset.view === view));
      });
      this.panels.forEach((panel) => {
        const active = panel.dataset.viewPanel === view;
        panel.hidden = !active;
        if (!active) {
          const video = panel.querySelector('video');
          if (video) video.pause();
        }
      });
    }
  }

  if (!customElements.get('spin-viewer')) customElements.define('spin-viewer', SpinViewer);
  if (!customElements.get('watch-split')) customElements.define('watch-split', WatchSplit);
  } catch(e) { console.error(e); }
})();

})();
